export default __webpack_public_path__ + "6658a3b6fc62d5c292508bffb3362a53.png";